// TODO: we will need to upload translations to OneSky and pull down
// the translations to put here
module.exports = {
  'Get the free app': 'Get the free app',
  'Download the free app': 'Download the free app',
  'Download the world’s leading photo editing app and join a global community of creators.':
    'Download the world’s leading photo editing app and join a global community of creators.',
};
